{
    "appId": "taxilla",
    "production": false,
    "envName": "local",
    "documentTitle": "enComply",
    "defaultProcessingUI": "enreport",
    "eninvoiceAppId": "envoice",
    "eninvoiceTags": [
        "eninvoice"
    ],
    "eninvoiceAutoSubscribeTags": [
        "ewb"
    ],
    "enreportTags": [
        "enreport",
        "taxilla"
    ],
    "encollabAutoSubscribeTags": [],
    "encollabTags": [
        "encollab"
    ],
    "logoHref": "encomply/",
    "marqueeText": "",
    "onLocalhost": true,
    "restrictedProcessingUIs": [],
    "returnPage": "returnPage",
    "showMarquee": false,
    "canShowAnalytics": true,
    "defaultLanguage": "en",
    "region": "IN",
    "hideSignUpPage": false,
    "taskManagement": {
        "show": true,
        "hideMinutes": false,
        "minNotifierHours": null
    },
    "hideSwitchSkin": false,
    "defaultNewUISkin": true,
    "orchestrationAssistant": true,
    "taxonomy": {
        "appApi": "mappingmaster",
        "aggregationSearchFieldIds": {
            "field1": "search_string_1",
            "field2": "search_string_2"
        },
        "displayFields": {
            "mapName": "mappingname",
            "version": "vers",
            "description": "mappingdescription",
            "status": "status",
            "lastModified": "versionto",
            "filter": "filter",
            "reportingStartDate": "effectivefrom",
            "reportingEndDate": "effectiveto"
        },
        "linksEntity": "mappingentity"
    },
    "taxilla_api": "https://remote.qa.taxilla.com/mapro",
    "taxilla_search_api": "https://remote.qa.taxilla.com/search",
    "taxilla_user_identity_api": "https://remote.qa.taxilla.com/idm",
    "notifications_api": "https://remote.qa.taxilla.com/notification",
    "oauth_api": "https://remote.qa.taxilla.com/oauth2",
    "eninvoice_api": "https://remote.qa.taxilla.com/app",
    "bundle_api": "https://remote.qa.taxilla.com/bundle-management",
    "recon_api": "https://remote.qa.taxilla.com/recon",
    "rule_generator_api": "https://remote.qa.taxilla.com/rule-generator",
    "analytics_api": "https://remote.qa.taxilla.com/analytics",
    "integration_api": "https://remote.qa.taxilla.com/integration",
    "task_management_api": "https://remote.qa.taxilla.com/orchestration",
    "catalogue_api": "https://remote.qa.taxilla.com/catalogue",
    "orchestration_assistant_api": "https://remote.qa.taxilla.com/orchestration-assistant",
    "encomply-ui": "https://local.qa.taxilla.com:4200",
    "enreport-ui": "https://local.qa.taxilla.com:4200/enreport",
    "eninvoice-ui": "https://local.qa.taxilla.com:4200/eninvoice",
    "encollab-ui": "https://local.qa.taxilla.com:4200/encollab",
    "enreconcile-ui": "https://local.qa.taxilla.com:4200/enreconcile",
    "gst-filing": "https://local.qa.taxilla.com:4200/gst-filing",
    "custom": "https://local.qa.taxilla.com:4200/custom",
    "auth-ui": "https://local.qa.taxilla.com:4200/auth",
    "macre-ui": "https://vdm.qa.taxilla.com",
    "clientId": "df08dbc4-55f4-48c2-b667-22789ebcf999"
}
